import React, { useEffect, useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../App.css';

const PagoExitosoPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orden = searchParams.get('orden') || '';
  const tipo = searchParams.get('tipo') || '';
  const esAfiliacion = tipo === 'afiliacion';
  const [segundosRestantes, setSegundosRestantes] = useState(5);

  // Redirigir al landing (/) después de 5 segundos
  useEffect(() => {
    let segundos = 5;
    const timer = setInterval(() => {
      segundos -= 1;
      setSegundosRestantes(segundos);
      if (segundos <= 0) {
        clearInterval(timer);
        navigate('/', { replace: true });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="main-container">
      <Header />
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
        <div style={{ textAlign: 'center', maxWidth: '480px' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>✓</div>
          <h1 style={{ fontSize: '24px', marginBottom: '12px', color: '#10b981' }}>¡Pago realizado con éxito!</h1>
          <p style={{ color: '#6b7280', marginBottom: '24px', lineHeight: 1.6 }}>
            Tu pago se ha procesado correctamente.
            {orden && (
              <span style={{ display: 'block', marginTop: '8px', fontWeight: 600, color: '#374151' }}>
                Número de pedido: {orden}
              </span>
            )}
          </p>
          {esAfiliacion ? (
            <>
              <p style={{ fontSize: '14px', color: '#374151', marginBottom: '12px', lineHeight: 1.6 }}>
                Tu afiliación se está procesando. Recibirás un correo con tu <strong>número de afiliación</strong> en breve.
              </p>
              <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px' }}>
                También puedes verlo en tu <Link to="/profile?from=payment" style={{ color: '#1a4d8c', fontWeight: 600 }}>perfil</Link> en unos segundos.
              </p>
            </>
          ) : (
            <p style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '24px' }}>
              Recibirás un correo con los detalles de tu compra.
            </p>
          )}
          <p style={{ fontSize: '13px', color: '#9ca3af', marginBottom: '24px' }}>
            Redirigiendo al inicio en {segundosRestantes} segundos...
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                background: '#dc2626',
                color: 'white',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none'
              }}
            >
              Ir al inicio
            </Link>
            <Link
              to="/profile?from=payment"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                background: '#1a4d8c',
                color: 'white',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none'
              }}
            >
              Ver mi perfil
            </Link>
            <Link
              to="/shop"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                background: 'transparent',
                color: '#374151',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontWeight: 600,
                textDecoration: 'none'
              }}
            >
              Ir a la tienda
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PagoExitosoPage;
